import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['item'];

  activate(event) {
    const link = event.currentTarget;

    if (link.dataset.state === 'active') {
      event.preventDefault();
      return;
    }

    this.itemTargets.forEach(el => (el.dataset.state = 'inactive'));
    link.dataset.state = 'active';
  }
}
